module.exports = __webpack_public_path__ + "assets/avatar-80a6f9.svg";